export const notifications = {
    methods: {
        /**
         * Push notifications to user.
         *
         * -- All colors
         *  {primary | secondary | danger | warning | success | info}
         *
         * -- All positions
         *  {b-toaster-top-right | b-toaster-top-left | b-toaster-top-center | b-toaster-top-full}
         *  {b-toaster-bottom-right | b-toaster-bottom-left | b-toaster-bottom-center | b-toaster-bottom-full}
         *
         * @param message
         * @param type
         * @param delay
         * @param position
         * @param append
         */
        pushNotification(message, type = 'success', delay = 7000, position = 'b-toaster-top-right', append = true) {
            this.$bvToast.toast(message, {
                title: this.$t('notifications.types.' + type),
                variant: type,
                solid: true,
                autoHideDelay: delay,
                toaster: position,
                appendToast: append
            })
        }
    }
};
